import * as XLSX from 'xlsx'
import { fmt, dateStr } from './formatters'

const calcUP = (comps, field = 'price') => {
  return comps.reduce((s, c) => s + c.coefficient * (c[field] || c.price || 0), 0)
}

export const exportRABToExcel = (project, rabItems, categories, oh, ppn) => {
  const wb = XLSX.utils.book_new()

  const gB = categories.reduce((s, c) => s + c.budget, 0)
  const gR = categories.reduce((s, c) => s + c.real, 0)
  const gtB = gB * (1 + oh / 100) * (1 + ppn / 100)
  const gtR = gR * (1 + oh / 100) * (1 + ppn / 100)

  const summaryData = [
    ['UNDAGI - RAB'],
    [`Proyek: ${project?.name || '-'}`],
    [`Tanggal Export: ${dateStr(new Date().toISOString())}`],
    [],
    ['RINGKASAN'],
    ['Item', 'Anggaran', 'Realisasi', 'Selisih'],
    ['Sub Total', gB, gR, gB - gR],
    [`OH & Profit (${oh}%)`, gB * oh / 100, gR * oh / 100, (gB - gR) * oh / 100],
    [`PPN (${ppn}%)`, gB * (1 + oh / 100) * ppn / 100, gR * (1 + oh / 100) * ppn / 100, (gB - gR) * (1 + oh / 100) * ppn / 100],
    ['GRAND TOTAL', gtB, gtR, gtB - gtR]
  ]

  const wsSummary = XLSX.utils.aoa_to_sheet(summaryData)
  XLSX.utils.book_append_sheet(wb, wsSummary, 'Ringkasan')

  const itemsData = [
    ['Kategori', 'Uraian', 'Unit', 'Volume', 'Real Volume', 'Harga Satuan', 'Total Anggaran', 'Total Realisasi']
  ]

  rabItems.forEach(it => {
    const budgetUP = calcUP(it.components || [], 'price')
    const realUP = calcUP(it.components || [], 'real_price')
    itemsData.push([
      it.category,
      it.item,
      it.unit,
      it.volume,
      it.real_volume || 0,
      budgetUP,
      it.volume * budgetUP,
      (it.real_volume || 0) * realUP
    ])
  })

  const wsItems = XLSX.utils.aoa_to_sheet(itemsData)
  XLSX.utils.book_append_sheet(wb, wsItems, 'Item RAB')

  XLSX.writeFile(wb, `RAB-${project?.name || 'Proyek'}.xlsx`)
}

export const exportInvoicesToExcel = (invoices, projects) => {
  const wb = XLSX.utils.book_new()

  const data = [
    ['No. Termin', 'Proyek', 'Deskripsi', 'Nilai', 'Tanggal', 'Jatuh Tempo', 'Status']
  ]

  invoices.forEach(inv => {
    const proj = projects.find(p => p.id === inv.project_id)
    data.push([
      inv.term_number,
      proj?.name || '-',
      inv.description,
      inv.amount,
      inv.date,
      inv.due_date,
      inv.status
    ])
  })

  const ws = XLSX.utils.aoa_to_sheet(data)
  XLSX.utils.book_append_sheet(wb, ws, 'Invoice')

  XLSX.writeFile(wb, `Invoice-Report.xlsx`)
}

export const exportAttendanceToExcel = (attendance, workers) => {
  const wb = XLSX.utils.book_new()

  const data = [
    ['Tanggal', 'Nama Pekerja', 'Jabatan', 'Status']
  ]

  attendance.forEach(att => {
    const worker = workers.find(w => w.id === att.worker_id)
    data.push([
      att.date,
      worker?.name || '-',
      worker?.role || '-',
      att.status
    ])
  })

  const ws = XLSX.utils.aoa_to_sheet(data)
  XLSX.utils.book_append_sheet(wb, ws, 'Absensi')

  XLSX.writeFile(wb, `Attendance-Report.xlsx`)
}

// Generic export to Excel
export const exportToExcel = (data, filename = 'Export') => {
  const ws = XLSX.utils.json_to_sheet(data)
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, 'Data')
  XLSX.writeFile(wb, `${filename}.xlsx`)
}